"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagIQ = function FlagIQ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M53.45-5.8c-.74-.39-1.62-1.77-1.35-2.37S52-8.75,53.46-8.3c2.75.71,4.52.39,6.27-1.1l1.54-1.22,1.81.9A6.64,6.64,0,0,0,65.41-9a5.08,5.08,0,0,0,2.42-3c0-1,.68-.7,1,.33.75,1.94-.62,5.28-2.49,5.73a5.1,5.1,0,0,1-3.17-.26c-1.68-.64-1.93-.64-2.84,0a6.33,6.33,0,0,1-6.91.39",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.52-13.27c-.91-1.27-2-5.72-1.68-6.8s.64-1.18,1.5-.91c1.54.54,1.9,1.54,1.72,5.17-.27,2.72-.63,3.62-1.54,2.54",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.2,6.36c-3.72,2.12-9.25,2.48-9.25,8.35-8.11.3-17.66.67-26.28.49,2.33-3,17.12-16.69,23.27-22.1a3.46,3.46,0,0,0,.77-3.85l-.16-.33a3,3,0,0,0-4.77-.86C-22.74-6.08-28.81-.62-29.81.32c-7.92,8-10.25,10.35-11.5,11.6a4.71,4.71,0,0,0-1.37,3.36v.08a4.75,4.75,0,0,0,4.75,4.73H-3.22c2,0-.46-6.83,2.08-6.83,1.77,0,1.93,2.45,1.85,5a3.65,3.65,0,0,1-3.66,3.54c-15,0-30.62.16-45.32.18a2.2,2.2,0,0,1-2.19-2.2V17.19a2.8,2.8,0,0,0-4.36-2.32L-55,15a2.49,2.49,0,0,0-1.1,2.9,8.77,8.77,0,0,1,.38,2.47,2.17,2.17,0,0,1-2.13,2.2c-4.86.15-10.14.2-11.64-2.67a3.19,3.19,0,0,0-4.28-1.56l-.22.11a3.37,3.37,0,0,0-1.46,4.65C-73.68,26.29-72,30-72.9,35.16a8.2,8.2,0,0,1-3.41,3.56A1.69,1.69,0,0,0-75,41.79a10.84,10.84,0,0,0,8.48-8.51H2.56a4.6,4.6,0,0,0,4.59-4.59v-15C6.52,9.21,1.71,9.39-.2,6.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M87.5-13.46a29.05,29.05,0,0,0,3.18,1.85,2.3,2.3,0,0,1,1,3.29,3.71,3.71,0,0,0-.45,1.07V22.51a4.85,4.85,0,0,0,4.13-.62,1.82,1.82,0,0,1,2.79,1c.7,2.6,1.85,5.16,2.46,7.48a2.28,2.28,0,0,1-2.2,2.87H86.74a1.87,1.87,0,0,1-1.87-1.87V-12a1.7,1.7,0,0,1,2.63-1.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.38-6.22c0,8.22.1,17.07.12,25.88a2.07,2.07,0,0,1-2.07,2.07H71.3a2.07,2.07,0,0,1-2.07-2.07V-1.21a1.32,1.32,0,0,0-2.18-1L64.31.16a2.52,2.52,0,0,0-.88,1.91c0,3.4,0,13.28,0,17.6a2.07,2.07,0,0,1-2.07,2.06h-.19a2.06,2.06,0,0,1-2.06-2.05c0-2.87-.06-8.2-.07-12.19a1.34,1.34,0,0,0-2.23-1,65.91,65.91,0,0,0-5,4.58c.12.79.72,0,1.08.6v4C42.55,13.73,41.78,22,42.16,30.84a2.49,2.49,0,0,0,2.48,2.37H77.07A2.17,2.17,0,0,0,79.24,31V-9.27a1.55,1.55,0,0,0-2.59-1.13c-.79.73-1.63,1.46-2.36,2.11a2.82,2.82,0,0,0-.91,2.07ZM49.52,21.43c-.63-1.82,2.93-2.48,3.35-.85.16,2-2.56,2.05-3.35.85Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-57.56,36.48a2.25,2.25,0,0,1,2.23,2.24A2.21,2.21,0,0,1-57.56,41a2.25,2.25,0,0,1-2.3-2.24,2.29,2.29,0,0,1,2.3-2.24",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.15-12.55c.61.36,1.23.71,1.89,1A2.19,2.19,0,0,1,19-8.37a3.51,3.51,0,0,0-.52,1.19V22.51a4.74,4.74,0,0,0,4.27-.68,1.66,1.66,0,0,1,2.59.91c.53,2,1.35,4,2,5.9a3.58,3.58,0,0,1-3.39,4.7H14.81a2.68,2.68,0,0,1-2.67-2.67V-10.25a2.66,2.66,0,0,1,4-2.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagIQ;
exports["default"] = _default;